import UserFormGroupInput from './Inputs/UserFormGroupInput.vue';
import PasswordForm from './Inputs/PasswordForm.vue';
import DualSelectInput from './Inputs/DualSelectInput.vue';

import DropDown from './Dropdown.vue';
import Button from './Button';

import Card from './Cards/Card.vue';
import ChartCard from './Cards/ChartCard.vue';
import StatsCard from './Cards/StatsCard.vue';
import InfoTooltip from './InfoTooltip.vue';

import SidebarPlugin from './SidebarPlugin/index';

import ModalComponent from './ModalComponent.vue';

let components = {
    UserFormGroupInput,
    PasswordForm,
    DualSelectInput,
    Card,
    ChartCard,
    StatsCard,
    InfoTooltip,
    DropDown,
    SidebarPlugin,
    ModalComponent,
};

export default components;

export {
    UserFormGroupInput,
    PasswordForm,
    DualSelectInput,
    Card,
    ChartCard,
    StatsCard,
    InfoTooltip,
    DropDown,
    Button,
    SidebarPlugin,
    ModalComponent,
};
